"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.propertyLinkingReducer = exports.propertyLinkingInitialState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var Actions = __importStar(require("./actions"));
exports.propertyLinkingInitialState = {
    address: {
        street: ''
    },
    openSearchProperty: undefined
};
exports.propertyLinkingReducer = (0, toolkit_1.createReducer)(exports.propertyLinkingInitialState, function (builder) {
    builder
        .addCase(Actions.setOpenSearchPropertyAction, function (state, action) {
        var _a, _b, _c, _d;
        var property = action.payload;
        state.openSearchProperty = property;
        state.address = {
            street: (_a = property.address_line_1) !== null && _a !== void 0 ? _a : '',
            unit: '',
            city: (_b = property.city) !== null && _b !== void 0 ? _b : '',
            state: (_c = property.state) !== null && _c !== void 0 ? _c : '',
            zipCode: (_d = property.postal_code) !== null && _d !== void 0 ? _d : ''
        };
        state.genericPortal = undefined;
    })
        .addCase(Actions.setCustomPropertyAddressAction, function (state, action) {
        var _a;
        var customAddress = action.payload;
        state.address = {
            street: customAddress.street,
            unit: (_a = customAddress.unit) !== null && _a !== void 0 ? _a : '',
            city: customAddress.city,
            state: customAddress.state,
            zipCode: customAddress.zipCode
        };
    })
        .addCase(Actions.setBillerPropertyDetailsAction, function (state, action) {
        var _a, _b, _c, _d, _e, _f, _g;
        var property = action.payload;
        state.property = property;
        state.address = {
            street: (_b = (_a = property.location) === null || _a === void 0 ? void 0 : _a.address_line_1) !== null && _b !== void 0 ? _b : '',
            unit: (_d = (_c = property.location) === null || _c === void 0 ? void 0 : _c.address_line_2) !== null && _d !== void 0 ? _d : '',
            city: (_e = property.location) === null || _e === void 0 ? void 0 : _e.city,
            state: (_f = property.location) === null || _f === void 0 ? void 0 : _f.state,
            zipCode: (_g = property.location) === null || _g === void 0 ? void 0 : _g.postal_code
        };
        state.genericPortal = undefined;
    })
        .addCase(Actions.setBillerPropertyPortalDetailsAction, function (state, action) {
        var portalDetails = action.payload;
        state.portalDetails = __assign(__assign({}, portalDetails), { display_name: portalDetails.display_name || portalDetails.portal_name });
        state.genericPortal = undefined;
    })
        .addCase(Actions.setBillerGenericPortalAction, function (state, action) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        state.property = undefined;
        var genericPortal = action.payload;
        state.genericPortal = genericPortal;
        var details = genericPortal.portal_display_config;
        var display_name = genericPortal.display_name === '' ? genericPortal.portal_name : genericPortal.display_name;
        state.portalDetails = {
            portal_name: genericPortal.portal_name,
            display_name: display_name,
            login_url: (_a = details === null || details === void 0 ? void 0 : details.login_url) !== null && _a !== void 0 ? _a : '',
            forgot_password_url: (_b = details === null || details === void 0 ? void 0 : details.forgot_password_url) !== null && _b !== void 0 ? _b : '',
            register_url: (_c = details === null || details === void 0 ? void 0 : details.register_url) !== null && _c !== void 0 ? _c : '',
            logo_url: (_d = details === null || details === void 0 ? void 0 : details.logo_url) !== null && _d !== void 0 ? _d : '',
            color_logo_url: (_e = details === null || details === void 0 ? void 0 : details.color_logo_url) !== null && _e !== void 0 ? _e : '',
            background_color: (_f = details === null || details === void 0 ? void 0 : details.background_color) !== null && _f !== void 0 ? _f : '',
            foreground_color: (_g = details === null || details === void 0 ? void 0 : details.foreground_color) !== null && _g !== void 0 ? _g : '',
            username_field_name: (_h = details === null || details === void 0 ? void 0 : details.username_field_name) !== null && _h !== void 0 ? _h : 'username',
            password_field_name: (_j = details === null || details === void 0 ? void 0 : details.password_field_name) !== null && _j !== void 0 ? _j : 'password'
        };
    })
        .addCase(Actions.setBillerUnitAction, function (state, action) {
        state.unit = action.payload;
    })
        .addCase(Actions.resetPropertyLinkingAction, function (state) {
        return __assign({}, exports.propertyLinkingInitialState);
    });
});
